module.exports = __webpack_public_path__ + "static/media/Mano 6.a5414fa7.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Mano 6.png
// module id = 188
// module chunks = 0